import { Material } from '../types';
import { SLAB_SPECIFICATIONS } from './customization';

// Each material has a fixed price per slab
const SLAB_PRICE = 999; // Base price for a standard slab

export const materials: Material[] = [
  {
    id: 'metallic-fusion',
    name: 'Metallic Fusion',
    image: 'https://images.unsplash.com/photo-1497436072909-60f360e1d4b1?w=800',
    description: 'Revolutionary metallic-infused porcelain with dynamic light-reflecting properties',
    price: SLAB_PRICE * 1.2, // 20% premium for innovative material
    popularity: 92,
    stock: 350,
    category: 'exclusives',
    finish: ['glossy', 'matte'],
    color: ['silver', 'metallic'],
    print: 'metallic',
    specifications: {
      hardness: 8,
      waterAbsorption: 0.05,
      scratchResistance: 9.5,
      heatResistance: 900,
      uvResistance: 9.5
    }
  },
  {
    id: 'calacatta-gold',
    name: 'Calacatta Gold Porcelain',
    image: 'https://images.unsplash.com/photo-1618221469555-7f3ad97540d6?w=800',
    description: 'Premium porcelain with elegant gold veining, perfect for luxury spaces',
    price: SLAB_PRICE,
    popularity: 98,
    stock: 500,
    category: 'porcelain',
    finish: ['glossy', 'matte'],
    color: ['white'],
    print: 'marble',
    specifications: {
      hardness: 7,
      waterAbsorption: 0.1,
      scratchResistance: 9,
      heatResistance: 800,
      uvResistance: 9
    }
  },
  {
    id: 'concrete-grey',
    name: 'Modern Concrete Grey',
    image: 'https://images.unsplash.com/photo-1600607686527-6fb886090705?w=800',
    description: 'Contemporary concrete-look porcelain with industrial appeal',
    price: SLAB_PRICE,
    popularity: 95,
    stock: 800,
    category: 'porcelain',
    finish: ['glossy', 'matte'],
    color: ['grey'],
    print: 'concrete',
    specifications: {
      hardness: 7,
      waterAbsorption: 0.1,
      scratchResistance: 8,
      heatResistance: 800,
      uvResistance: 9
    }
  },
  {
    id: 'ivory-terrazzo',
    name: 'Classic Ivory Terrazzo',
    image: 'https://images.unsplash.com/photo-1600566752355-35792bedcfea?w=800',
    description: 'Timeless terrazzo-inspired porcelain with delicate aggregate pattern',
    price: SLAB_PRICE,
    popularity: 96,
    stock: 650,
    category: 'porcelain',
    finish: ['glossy', 'matte'],
    color: ['ivory'],
    print: 'terrazzo',
    specifications: {
      hardness: 7,
      waterAbsorption: 0.1,
      scratchResistance: 8,
      heatResistance: 800,
      uvResistance: 9
    }
  },
  {
    id: 'nero-marquina',
    name: 'Nero Marquina',
    image: 'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=800',
    description: 'Dramatic black marble-look porcelain with striking white veining',
    price: SLAB_PRICE,
    popularity: 94,
    stock: 450,
    category: 'porcelain',
    finish: ['glossy', 'matte'],
    color: ['black'],
    print: 'marble',
    specifications: {
      hardness: 7,
      waterAbsorption: 0.1,
      scratchResistance: 9,
      heatResistance: 800,
      uvResistance: 9
    }
  },
  {
    id: 'travertine-beige',
    name: 'Natural Travertine',
    image: 'https://images.unsplash.com/photo-1600566752229-250b0ffe885d?w=800',
    description: 'Authentic travertine-look porcelain with natural variations',
    price: SLAB_PRICE,
    popularity: 93,
    stock: 700,
    category: 'porcelain',
    finish: ['glossy', 'matte'],
    color: ['beige'],
    print: 'stone',
    specifications: {
      hardness: 7,
      waterAbsorption: 0.1,
      scratchResistance: 8,
      heatResistance: 800,
      uvResistance: 9
    }
  },
  {
    id: 'wood-oak',
    name: 'Classic Oak',
    image: 'https://images.unsplash.com/photo-1600607687668-0b7b08d9d1a5?w=800',
    description: 'Realistic wood-look porcelain with natural oak grain patterns',
    price: SLAB_PRICE,
    popularity: 92,
    stock: 900,
    category: 'porcelain',
    finish: ['glossy', 'matte'],
    color: ['brown'],
    print: 'wood',
    specifications: {
      hardness: 7,
      waterAbsorption: 0.1,
      scratchResistance: 8,
      heatResistance: 800,
      uvResistance: 9
    }
  }
];